import { render, staticRenderFns } from "./OverlayForm.vue?vue&type=template&id=c350ce3e&"
import script from "./OverlayForm.vue?vue&type=script&lang=js&"
export * from "./OverlayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports